import { render, staticRenderFns } from "./LastUserBubble.vue?vue&type=template&id=5d4bc7fc"
import script from "./LastUserBubble.vue?vue&type=script&lang=js"
export * from "./LastUserBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports